import React from "react";
import { Grid } from "@mui/material";
import {
  ArrowBackIosNewSharp,
  ArrowBackIosNewRounded,
  ArrowCircleLeftSharp,
  ArrowCircleRightSharp,
  ArrowCircleLeftOutlined,
  ArrowCircleRight,
  ArrowCircleRightOutlined,
  NextPlan,
  Menu,
} from "@mui/icons-material";
import { openSidebarMenu } from "../../store/actions/sideBarMenuActions";
import SideBarNavigation from "../../parts/SideBarNavigation/SideBarNavigation";
import MusicPlayer from "../../MusicPlayer/components/MusicPlayer";
import Footer from "../../parts/Footer/Footer";
import Discover from "./../Discover/Discover";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";
import { goBack, goForward } from "connected-react-router";
import Home from "../Home/Home";
import { useDispatch } from "react-redux";
import { useTheme } from "styled-components";
import useResize from "../../hooks/resize";
export default function Index() {
  const device = useResize();
  const theme = useTheme();
  const footerHeight = theme.footer.height;
  const navigationBarHeight = theme.navigationBarHeight;
  const dispatch = useDispatch();
  return (
    <Grid container direction="row">
      <Grid xs={0} sm={0} md={3} lg={2.5} xl={3}>
        <SideBarNavigation />
      </Grid>
      <Grid
        xs={12}
        sm={12}
        md={9}
        lg={9.5}
        xl={9}
        className="main-content"
        style={{
          height: `calc(100vh - ${footerHeight} - ${navigationBarHeight}`,
        }}>
        <div
          style={{
            width: "100%",
            height: navigationBarHeight,
            display: "flex",
            flexFlow: "row",
            alignItems: "center",
            paddingLeft: 8,
          }}>
          <ArrowCircleLeftOutlined
            color="gray"
            style={{ fontSize: "36px" }}
            onClick={() => {
              dispatch(goBack());
            }}
          />
          <ArrowCircleRightOutlined
            onClick={() => dispatch(goForward())}
            color="gray"
            style={{ fontSize: "36px" }}
          />
          <Menu
            onClick={() => dispatch(openSidebarMenu())}
            color="white"
            style={{
              float: "right",
              display:
                device === "mobile" ||
                device === "smallMobile" ||
                device === "tablet"
                  ? "block"
                  : "none",
            }}
          />
        </div>
        <Switch>
          <Route exact path={`/`} component={Home}></Route>
          <Route exact path={`/discover`} component={Discover}></Route>
        </Switch>
      </Grid>
      <Footer>
        <MusicPlayer />
      </Footer>
    </Grid>
  );
}
